// Function to get the value of a specific query parameter
function getQueryParam(param) {
    var searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(param);
}

// Function to store the affiliate ID in localStorage
function storeAffiliateReferral() {
    var affiliateID = getQueryParam('ref'); // 'ref' is the query parameter
    if (affiliateID) {
        localStorage.setItem('marullo_affiliate', affiliateID);
    }
}

// Execute the function when the page loads
document.addEventListener('DOMContentLoaded', storeAffiliateReferral);